
import { Component, Prop, Vue } from "vue-property-decorator";
import RouterLink from "~/components/atoms/text/RouterLink.vue";
import { FuelProductType } from "~/types";

@Component({
  components: {
    RouterLink,
  },
})
export default class CityListSection extends Vue {
  @Prop({ required: true }) fuelProductType!: FuelProductType;
  @Prop({ required: true }) stateName!: string;
  @Prop({ required: true }) cityLinks!: Array<
    {
      name: string;
      link: string;
    }[]
  >;

  get fuelProductLabel(): string {
    if (this.fuelProductType === "oil") {
      return "Heizölpreis";
    }
    return "Pelletspreis";
  }
}
